// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.history-loading-wrapper {
  padding: 5px 16px;
  display: inline-block;
  width: 100%;
}
.history-loading-wrapper .history-bg-content {
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid var(--sdk-gloabl-border-color);
  background: var(--sdk-gloabl-bg-secondary);
  padding: 10px 15px;
  gap: 10px;
  min-height: 40px;
  justify-content: center;
}
.history-loading-wrapper .history-bg-content .loader-history {
  border: 2px solid var(--sdk-global-white-bg);
  border-radius: 50%;
  border-top: 2px solid var(--sdk-global-theme-color);
  width: 16px;
  height: 16px;
  -webkit-animation: spinLoader 2s linear infinite;
  animation: spinLoader 2s linear infinite;
  flex-shrink: 0;
}
.history-loading-wrapper .history-bg-content .title-loading {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/base/misc/historyLoaderMsg/historyLoaderMsg.scss"],"names":[],"mappings":"AAEA;EACI,iBAAA;EACA,qBAAA;EACA,WAAA;AADJ;AAEI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gDAAA;EACA,0CAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;AAAR;AACQ;EACI,4CAAA;EACA,kBAAA;EACA,mDAAA;EACA,WAAA;EACA,YAAA;EACA,gDAAA;EACA,wCAAA;EACA,cAAA;AACZ;AACQ;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;AACZ","sourcesContent":["// History Loader css\n\n.history-loading-wrapper{\n    padding: 5px 16px;\n    display: inline-block;\n    width: 100%;\n    .history-bg-content{\n        display: flex;\n        align-items: center;\n        border-radius: 4px;\n        border: 1px solid var(--sdk-gloabl-border-color);\n        background: var(--sdk-gloabl-bg-secondary);\n        padding: 10px 15px;\n        gap: 10px;\n        min-height: 40px;\n        justify-content: center;\n        .loader-history{\n            border: 2px solid var(--sdk-global-white-bg);\n            border-radius: 50%;\n            border-top: 2px solid var(--sdk-global-theme-color);\n            width: 16px;\n            height: 16px;\n            -webkit-animation: spinLoader 2s linear infinite;\n            animation: spinLoader 2s linear infinite;\n            flex-shrink: 0;\n        }\n        .title-loading{\n            color: var(--sdk-gloabl-text-color);\n            font-size: 14px;\n            font-weight: 500;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
